import { useState } from 'react';
import { AdminDemoData } from '@platform/client';
import { AdminFormModal, ModalStage } from '../../AdminFormModal';

export const CreateDemoFundingOpportunityModal = (props: { onClose: () => void }) => {
  const [modalStage, setModalStage] = useState<ModalStage>('form');
  const [successText, setSuccessText] = useState<string>();

  const createFundingOpportunityMutator = AdminDemoData.useCreateDemoFundingOpportunity({
    mutation: {
      onMutate: () => setModalStage('submitting'),
      onError: () => setModalStage('error'),
      onSuccess: (data) => {
        setSuccessText(
          `Funding opportunity #${data.fundingOpportunityId} ("${data.title}") created.`,
        );
        setModalStage('success');
      },
    },
  });

  return (
    <AdminFormModal
      title='Create Demo Funding Opportunity'
      onClose={props.onClose}
      modalStage={modalStage}
      successText={successText}
      submitCTA={{
        text: 'Create',
        callback: () => createFundingOpportunityMutator.mutate(),
      }}
    >
      <p className='text-sm text-gray-600'>
        Creates a realistic funding opportunity (with a future deadline) to show off on the
        community page — no configuration needed.
      </p>
    </AdminFormModal>
  );
};
